import React from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import Image from './image'
import Icon from './icon'
import Text from './text'
import { me } from '../initial_state'
import RelativeTimestamp from './relative_timestamp'
import DisplayName from './display_name'
import Avatar from './avatar'
import Blurhash from './blurhash'

class StatusVideoClip extends React.PureComponent {
  state = {
    isLoaded: false,
    isHovering: false,
  }

  handleOnMouseEnter = () => {
    this.setState({ isHovering: true })
  }
  
  handleOnMouseLeave = () => {
    this.setState({ isHovering: false })
  }

  handleOnClick = () => {
    const { status, account, history, onlyFollowing, withTimeline } = this.props
    let query = ''
    if (history.location.pathname === '/timeline/clips' || withTimeline) query = '?timeline=video-clips' 
    if (onlyFollowing && !!me) {
      if (query.length > 1) query += '&only_following=1'
      else query = '?only_following=1'
    }
    const url = `/${account.get('acct')}/posts/${status.get('id')}/media/1${query}`
    history.push(url, {
      state: {
        location: history.location,
        scrollY: window.scrollY || window.pageYOffset,
      }
    })
  }

  handleOnLoad = () => {
    this.setState({ isLoaded: true })
  }

  render() {
    const { isHovering, isLoaded } = this.state
    const { status, account, withMeta } = this.props
    
    if (!status) return null
  
    const title = status.get('text') || ''
    const maxTitle = 70
    const truncatedTitle = title.length >= maxTitle ? `${title.substring(0, maxTitle).trim()}...` : title

    const allMedia = status.get('media_attachments')
    if (!allMedia) return null
    const media = allMedia.get(0)
    if (!media || media.get('type') !== 'video') return null

    // : todo :
    // use canShow here
    
    return (
      <div
        onMouseEnter={this.handleOnMouseEnter}
        onMouseLeave={this.handleOnMouseLeave}
        onClick={this.handleOnClick}
        className={[_s.d, _s.w100PC, _s.maxW340PX, _s.noUnderline].join(' ')}
      >
        <div className={[_s.d, _s.w100PC, _s.pt175PC, _s.overflowHidden, _s.radiusTiny].join(' ')}>
          <div className={[_s.d, _s.posAbs, _s.top0, _s.right0, _s.left0, _s.bottom0].join(' ')}>
            {
              !isLoaded &&
              <Blurhash hash={media.get('blurhash')} className={[_s.d, _s.h100PC, _s.w100PC].join(' ')} />
            }

            <Image cfWidthPX='340px' height='100%' onLoad={this.handleOnLoad} src={media.get('preview_url')} className={[_s.d, _s.w100PC, _s.h100PC, _s.z2].join(' ')} />

            {
              isHovering &&
              <div className={[_s.d, _s.posAbs, _s.jcCenter, _s.top0, _s.left0, _s.bottom0, _s.right0, _s.z1].join(' ')}>
                <video src={media.get('source_mp4')} autoPlay type='video/mp4' loop muted playsInline controls={false} className={[_s.d, _s.objectFitCover, _s.w100PC, _s.h100PC].join(' ')} />
              </div>
            }

            <div className={[_s.d, _s.posAbs, _s.radiusSmall, _s.bgBlackOpaquer, _s.px5, _s.py5, _s.mr5, _s.mt5, _s.mb5, _s.bottom0, _s.right0, _s.z3].join(' ')}>
              <span className={[_s.text, _s.d, _s.cWhite].join(' ')} style={{fontSize:'10px'}}>
                {`${parseInt(media.getIn(['meta', 'duration']))}s`}
              </span>
            </div>
          </div>
        </div>
        {
          !!title && withMeta && 
          <div className={[_s.d, _s.w100PC, _s.aiStart, _s.pt10].join(' ')}>
            <div
              className={[_s.statusContent, _s.outlineNone].join(' ')}
              dangerouslySetInnerHTML={{ __html: truncatedTitle }}
            />
          </div>
        }
        {
          withMeta &&
          <div className={[_s.d, _s.w100PC, _s.flexRow, _s.aiStart, _s.pt10].join(' ')}>
            <Avatar account={account} size='30px' />
            <div className={[_s.d, _s.flex1, _s.pl10].join(' ')}>
              <div>
                <DisplayName isSmall isInline noUsername account={account} />
              </div>
              <div>
                <Text color='secondary' size='small'>
                  <RelativeTimestamp timestamp={status.get('created_at')} />
                </Text>
              </div>
            </div>
          </div>
        }
      </div>
    )
  }

}

const mapDispatchToProps = (dispatch) => ({
  // 
})

const mapStateToProps = (state, props) => {
  const statusId = props.id || props.statusId
  const status = state.getIn(['statuses', statusId])
  return {
    status,
    account: status ? state.getIn(['accounts', status.get('account')]) : null,
  }
}

StatusVideoClip.propTypes = {
  statusId: PropTypes.string.isRequired,
  withMeta: PropTypes.bool,
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(StatusVideoClip))